import React from "react";
import Slider from "react-slick";

function MediaSlider({ mediaItems = [] }) {
  const settings = {
    centerMode: true,
    centerPadding: "80px",
    slidesToShow: 2.8,
    speed: 500,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerPadding: "40px"
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          centerPadding: "40px"
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "20px"
        }
      }
    ]
  };

  return (
    <>
      <Slider {...settings}>
        {mediaItems.map((item, index) => {
          const date = new Date(item.createdAt).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric"
          });

          // Alternate card color
          const isEven = index % 2 === 0;
          const bgColor = isEven ? "#FDD60D" : "#6953A3";
          const textColor = isEven ? "#263238" : "#FFFFFF";

          return (
            <div key={item._id} >
              <div className="relative px-[10px] flex items-center flex-col">
                <div className="pb-[140px]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-[400px] h-[256px] object-cover rounded-[12px]"
                  />
                </div>
                <div
                  className="max-w-[359px] absolute left-[50%] translate-x-[-50%] w-full bottom-[10px] px-[20px] py-[18px] bg-[#FDD60D] rounded-[20px] h-[162px]"
                  style={{ backgroundColor: bgColor }}
                >
                  <p
                    className="font-[400] text-[16px] font-sans text-[#263238] pb-[7px]"
                    style={{ color: textColor }}
                  >
                    {date}
                  </p>
                  <p
                    className="font-[400] font-sans text-[16px] text-[#000000] pb-[16px]"
                    style={{ color: textColor }}
                  >
                    {item.title}
                  </p>
                  <button
                    className="font-[500] font-sans text-[16px] leading-[24px] uppercase flex gap-[6px] items-center"
                    style={{ color: textColor }}
                  >
                    Read More <img src={isEven ? "/assets/media/arrow-black.svg" : "/assets/media/arrow-white.svg"} alt="" />
                  </button>
                </div>
              </div>
            </div>
          );
        })}
        {/* <div>
          <div className="relative px-[10px] flex items-center flex-col">
            <img src="/assets/media/img1.png" className="pb-[140px]" alt="" />
            <div className="max-w-[359px] absolute left-[50%] translate-x-[-50%] w-full bottom-[10px] px-[20px] py-[18px] bg-[#FDD60D] rounded-[20px]">
              <p className="font-[400] text-[16px] font-sans text-[#263238] pb-[7px]">
                July 16, 2024
              </p>
              <p className="font-[400] font-sans text-[16px] text-[#000000] pb-[16px]">
                edForce Takes Home Prestigious Awards at The Indian Brand &
                Leadership{" "}
              </p>
              <button className="font-[500] font-sans text-[16px] leading-[24px] uppercase text-[#263238]">
                Read More
              </button>
            </div>
          </div>
        </div>
        <div>
          <div className="relative px-[10px] flex items-center flex-col">
            <img src="/assets/media/img2.png" className="pb-[140px]" alt="" />
            <div className="max-w-[359px] absolute left-[50%] translate-x-[-50%] w-full bottom-[10px] px-[20px] py-[18px] bg-[#6953A3] rounded-[20px]">
              <p className="font-[400] text-[16px] font-sans text-[#FFFFFF] pb-[7px]">
                July 16, 2024
              </p>
              <p className="font-[400] font-sans text-[16px] text-[#FFFFFF] pb-[16px]">
                edForce Takes Home Prestigious Awards at The Indian Brand &
                Leadership{" "}
              </p>
              <button className="font-[500] font-sans text-[16px] leading-[24px] uppercase text-[#FFFFFF]">
                Read More
              </button>
            </div>
          </div>
        </div>
        <div>
          <div className="relative px-[10px] flex items-center flex-col">
            <img src="/assets/media/img1.png" className="pb-[140px]" alt="" />
            <div className="max-w-[359px] absolute left-[50%] translate-x-[-50%] w-full bottom-[10px] px-[20px] py-[18px] bg-[#FDD60D] rounded-[20px]">
              <p className="font-[400] text-[16px] font-sans text-[#263238] pb-[7px]">
                July 16, 2024
              </p>
              <p className="font-[400] font-sans text-[16px] text-[#000000] pb-[16px]">
                edForce Takes Home Prestigious Awards at The Indian Brand &
                Leadership{" "}
              </p>
              <button className="font-[500] font-sans text-[16px] leading-[24px] uppercase text-[#263238]">
                Read More
              </button>
            </div>
          </div>
        </div>
        <div>
          <div className="relative px-[10px] flex items-center flex-col">
            <img src="/assets/media/img2.png" className="pb-[140px]" alt="" />
            <div className="max-w-[359px] absolute left-[50%] translate-x-[-50%] w-full bottom-[10px] px-[20px] py-[18px] bg-[#6953A3] rounded-[20px]">
              <p className="font-[400] text-[16px] font-sans text-[#FFFFFF] pb-[7px]">
                July 16, 2024
              </p>
              <p className="font-[400] font-sans text-[16px] text-[#FFFFFF] pb-[16px]">
                edForce Takes Home Prestigious Awards at The Indian Brand &
                Leadership{" "}
              </p>
              <button className="font-[500] font-sans text-[16px] leading-[24px] uppercase text-[#FFFFFF]">
                Read More
              </button>
            </div>
          </div>
        </div> */}
      </Slider>
    </>
  );
}

export default MediaSlider;
